module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABIUlEQVR42o3TsYrCMBzH8XsdQXFzEtxd3MRNOXC+SZcb6iO4+hKCIG5OLg4KLi7FoeAiFJqWtqRpY36X5rii1lz6hy8lkHygKf0AoLIsCxX6luV7i3NPAGMMlNJSSZI8Il9aIB/btkvJyQ/+Pe+yTy3gOM5rBfAQ1QKu65Z6GYVoAc/z3kZmM5DBwAzEcVwqOp1AGg2E67UZkDf+nO8j6PdBmk3Q280McM6LMnk4mk7ht9sIej1wxswAW60gCEF2OCAcDkEXC4Ty3cPRqNolkloNQaeDaDxGutkojNTr1YFsv1eb+fms1ulu94t2u3KRmgGFHI+IJxNACLDlMgfUV7hfr0agGDqfg18uCvBbLVW63RaA9mcSQvyb3KMHKvYE/AATKCkZNWgL9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/application-pdf.png
// module id = AeDo
// module chunks = 1